const AdvertiseIcon = () => (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#advertise-clip)">
            <path
                d="M14.6128 26.2028C12.7241 26.9132 10.632 25.9051 9.94462 23.9535L8.72284 20.4848L6.82445 20.5658C5.4713 20.6239 4.24562 19.7778 3.78203 18.4617L3.09372 16.5075C2.62924 15.1888 3.03955 13.7317 4.11545 12.8748L14.5632 4.54346C14.8024 4.3511 15.066 4.20075 15.3492 4.09424C16.8611 3.52561 18.5384 4.33693 19.0887 5.89925L22.6333 15.9627C23.1836 17.525 22.4034 19.2606 20.8915 19.8292C20.6083 19.9357 20.3129 19.9957 20.01 20.0072L16.3611 20.1635L16.7902 21.3817C17.4776 23.3334 16.5021 25.4951 14.6134 26.2055L14.6128 26.2028ZM11.1892 23.4854C11.6262 24.7262 12.959 25.3684 14.1598 24.9168C15.3606 24.4652 15.9821 23.088 15.545 21.8471L14.9709 20.217L10.1111 20.4248L11.1892 23.4854ZM19.9531 18.6376C20.1194 18.6291 20.2807 18.5983 20.4338 18.5407C21.2578 18.2308 21.6853 17.2835 21.384 16.4283L17.8394 6.36483C17.5381 5.50957 16.6214 5.06786 15.7974 5.37778C15.6418 5.43628 15.4988 5.51854 15.369 5.62283L4.92121 13.9542C4.3053 14.4447 4.07172 15.282 4.3367 16.0343L5.02501 17.9885C5.29131 18.7445 5.9898 19.2271 6.76673 19.1937L19.9527 18.6364L19.9531 18.6376Z"
                fill="url(#advertise-gradient-fill)"
                stroke="url(#advertise-gradient-stroke)"
                strokeWidth="0.946061"
            />
            <path
                d="M26.0488 12.4452L23.809 6.08617"
                stroke="url(#advertise-gradient-accent)"
                strokeWidth="2.42145"
                strokeLinecap="round"
            />
        </g>
        <defs>
            <linearGradient
                id="advertise-gradient-fill"
                x1="18.1234"
                y1="3.79523"
                x2="-2.61841"
                y2="29.0311"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#9013FE" />
                <stop offset="1" stopColor="#E646B6" />
            </linearGradient>
            <linearGradient
                id="advertise-gradient-stroke"
                x1="18.1234"
                y1="3.79523"
                x2="-3.41341"
                y2="29.387"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#9013FE" />
                <stop offset="1" stopColor="#E646B6" />
            </linearGradient>
            <linearGradient
                id="advertise-gradient-accent"
                x1="20.6878"
                y1="10.3625"
                x2="25.6387"
                y2="7.7288"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#6157FF" />
                <stop offset="1" stopColor="#9933FF" />
            </linearGradient>
            <clipPath id="advertise-clip">
                <rect width="28.3333" height="28.3333" fill="white" transform="translate(0.666504 0.333374)" />
            </clipPath>
        </defs>
    </svg>
)

export default AdvertiseIcon
